import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
export default function CreateWaveInlineGroupExpandedPanel(t0) {
  const $ = _c(9);
  const {
    children,
    onCancel,
    cancelClassName: t1,
    cancelLabel: t2
  } = t0;
  const cancelClassName = t1 === undefined ? "" : t1;
  const cancelLabel = t2 === undefined ? "Cancel" : t2;
  let t3;
  if ($[0] !== children) {
    t3 = <div className="tw-min-w-0 tw-flex-1">{children}</div>;
    $[0] = children;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = `tw-flex-shrink-0 tw-rounded-lg tw-border tw-border-solid tw-border-transparent tw-bg-transparent tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-text-iron-500 tw-transition tw-duration-200 desktop-hover:hover:tw-text-iron-100 ${cancelClassName}`;
  let t5;
  if ($[2] !== cancelLabel || $[3] !== onCancel || $[4] !== t4) {
    t5 = <button type="button" onClick={onCancel} className={t4}>{cancelLabel}</button>;
    $[2] = cancelLabel;
    $[3] = onCancel;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t3 || $[7] !== t5) {
    t6 = <div className="tw-relative tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-white/5 tw-pt-5"><div className="tw-flex tw-items-start tw-gap-3">{t3}{t5}</div></div>;
    $[6] = t3;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}